<div #selector class="multilevel-selector" [ngClass]="{'multilevel-selector-disabled':user.roleId === 4}">
    <div class="multilevel-selector-head" [ngClass]="{'multilevel-selector-head-opened':showDropdown}"
        (click)="toogleDropdown()">
        <span>
            {{multilevelSelectorHeadNumber > 1 ? '('+multilevelSelectorHeadNumber+')' : ''}}
            {{(multilevelSelectorHead ? multilevelSelectorHead : 'DATATABLE.FILTERS.ENTITY') | translate}}
        </span>
        <span *ngIf="clearSelectorPB" (click)="clear($event)" class="ng-clear-wrapper" title="Clear all"><span
                aria-hidden="true" class="ng-clear">×</span></span>
    </div>
    <div *ngIf="showDropdown" class="multilevel-selector-dropdown">
        <div *ngFor="let item of data; index as i">
            <div class="multilevel-selector-dropdown-search-container">
                <input type="search" class="form-control" [placeholder]="'DATATABLE.SEARCH' | translate"
                    [(ngModel)]="selectorSearch" (ngModelChange)="onChange($event,'search')"
                    (keyup)="applyFilters()" [ngModelOptions]="{standalone: true}" >
            </div>
            <!--<div class="multi-level-item">
                <input id="entity-multilevel-item-{{ i }}" type="checkbox" [(ngModel)]="item!.selected"
                    (change)="change($event,item)" />
                <span (click)="toogle(item)">{{item.target.name}}</span>
            </div>-->
            <div *ngIf="item.opened" class="multi-level-item-container">
                <hbo-multi-select-multi-level-item [hidden]="!item.visible" [typeData]="typeData" [search]="selectorSearch" [item]="item" [data]="item.childs"
                    [selected]="item.selected" (callbackVisible)="visibleEntity($event)" (callback)="setShops($event)"></hbo-multi-select-multi-level-item>
            </div>
        </div>
    </div>
</div>